import styled from 'styled-components/macro';

export const TreeNodeItem = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  color: #7f7f7f;
  cursor: pointer;

  .triangle-icon {
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 1.2rem;
  }

  .glyphicon {
    font-size: 1rem;
  }
`;
